import useStandFilterHook from "./use-stand-filter-hook";


const StandHooks = {
    useFilter : useStandFilterHook
}

export default StandHooks;